import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { get } from "../../lib/request"

function normalizeAlertType(row) {
  if (!row || typeof row !== "object") return null
  const id = row.id ?? row.alertTypeId ?? row.alert_type_id
  const description = row.description ?? row.name ?? row.label ?? ""
  if (id == null || id === "") return null
  return { id, description: String(description) }
}

function normalizeAlertTypesList(raw) {
  const list = Array.isArray(raw) ? raw : raw?.data ?? raw?.types ?? []
  if (!Array.isArray(list)) return []
  return list.map(normalizeAlertType).filter(Boolean)
}

export const fetchAlertTypes = createAsyncThunk(
  "alertTypes/fetchAlertTypes",
  async (_, { rejectWithValue }) => {
    try {
      const data = await get("alerts/types")
      return normalizeAlertTypesList(data)
    } catch (err) {
      return rejectWithValue(err?.message || "Failed to fetch alert types")
    }
  },
)

const alertTypesSlice = createSlice({
  name: "alertTypes",
  initialState: {
    types: [],
    typesLoading: false,
    typesError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAlertTypes.pending, (state) => {
        state.typesLoading = true
        state.typesError = null
      })
      .addCase(fetchAlertTypes.fulfilled, (state, action) => {
        state.typesLoading = false
        state.types = action.payload
      })
      .addCase(fetchAlertTypes.rejected, (state, action) => {
        state.typesLoading = false
        state.typesError = action.payload
      })
  },
})

export default alertTypesSlice.reducer
